/*
 *
 * AppValidations reducer
 *
 */
import produce from 'immer';
import { LOAD_VERSIONS_REQUEST, LOAD_VERSIONS_SUCCESS, LOAD_VERSIONS_FAILURE, VERSIONS_QUERY, LOAD_USERS_REQUEST, LOAD_USERS_SUCCESS, LOAD_USERS_FAILURE, } from './constants';
export var initialState = {
    loading: false,
    updating: false,
    error: false,
    touched: false,
    formValidity: true,
    searchQuery: null,
    users: [],
    versions: [],
};
function appValidationsReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        switch (action.type) {
            case LOAD_USERS_REQUEST:
                state.userLoading = true;
                state.error = false;
                break;
            case LOAD_USERS_SUCCESS:
                state.userLoading = false;
                state.error = false;
                state.users = action.users;
                break;
            case LOAD_USERS_FAILURE:
                state.userLoading = false;
                state.error = true;
                break;
            case LOAD_VERSIONS_REQUEST:
                state.loading = true;
                state.error = false;
                break;
            case LOAD_VERSIONS_SUCCESS:
                state.loading = false;
                state.error = false;
                state.touched = false;
                state.versions = action.versions;
                state.searchQuery = null;
                break;
            case LOAD_VERSIONS_FAILURE:
                state.loading = false;
                state.error = true;
                state.versions = [];
                state.searchQuery = null;
                break;
            case VERSIONS_QUERY: {
                state.searchQuery = action.searchQuery || null;
                break;
            }
            default:
                break;
        }
    });
}
export default appValidationsReducer;
